import { combineReducers } from 'redux';
import auth from './auth';
import tree from './tree';
import farm from './farm';
import form from './form';

export default combineReducers({
    auth, tree, farm, form
});
